// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__vdXP-","hybrid888":"SearchBar_hybrid888__sjrbt","desktop":"SearchBar_desktop__Bn4qj"};